module.exports = __webpack_public_path__ + "img/frais.05132656.png";